import Offcanvas from "./offcanvas";
import Scrollspy from "./scrollspy";
import Dropdown from "./dropdown";

export default {
  Offcanvas,
  Scrollspy,
  Dropdown,
};
